import { BrandAuthLogo } from '~/brand/BrandContext';

export function LogoSection() {
  return (
    <div
      className={
        'hidden h-screen items-center justify-center bg-gradient-to-b from-brand to-slate-dark lg:flex lg:w-1/2'
      }
    >
      <BrandAuthLogo className='w-1/2' />
    </div>
  );
}
